<template>
  <div>
    <b-card class="shadow-lg p-0 p-sm-2 text-center">
      <h3 class="mb-xl-5 mb-4">
        Dates et horaires disponibles pour votre prochain
        <strong>rendez-vous</strong>
      </h3>
      <b-form-group>
        <b-form-radio-group
          id="btn-radios-2"
          v-model="distancial"
          :options="distancialList"
          buttons
          button-variant="outline-primary"
          size="lg"
          name="radio-btn-outline"
        ></b-form-radio-group>
      </b-form-group>
      <div v-if="office && !distancial">
        <h5>{{ office.name }}</h5>
        <p>
          <span v-if="office.address">Adresse : <b>{{ office.address }}</b><br /></span>
          <span v-if="office.phone">Numéro de téléphone : <b>{{ office.phone }}</b></span>
        </p>
      </div>
      <div class="d-flex">
        <b-button variant="link" v-on:click="moveCalendar(false)" v-if="previousWeek"><font-awesome-icon :icon="['fad', 'angle-left']" size="lg" class="mr-1 float-left" />Semaine précédente</b-button>
        <b-button variant="link" v-on:click="moveCalendar(true)" class="ml-auto"><font-awesome-icon :icon="['fad', 'angle-right']" size="lg" class="ml-1 float-right" /> Semaine suivante</b-button>
      </div>
      <Calendar
        class="mt-2"
        v-on:update="selectAppointment"
        :date="date"
        :office="office"
        :distancial="distancial"
        :action="action"
      />
      <div class="d-flex mt-4 d-xl-none">
        <b-button variant="link" v-on:click="moveCalendar(false)" v-if="previousWeek"><font-awesome-icon :icon="['fad', 'angle-left']" size="lg" class="mr-1 float-left" />Semaine précédente</b-button>
        <b-button variant="link" v-on:click="moveCalendar(true)" class="ml-auto"><font-awesome-icon :icon="['fad', 'angle-right']" size="lg" class="ml-1 float-right" /> Semaine suivante</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>

import Calendar from "./Calendar.vue";
import moment from "moment";
import Distancials from "../data/distancials.json";

export default {
  name: "Appointment",
  components: {
    Calendar,
  },
  props: {
    office: Object,
    action: String
  },

  data() {
    return {
      displayCalendar: false,
      distancial: true,
      distancialList: Distancials,
      isLoading: true,
      date: new Date(),
    };
  },
  
  computed: {
    previousWeek() {
      return moment(this.date).isoWeekday(1).isAfter();
    }
  },

  methods: {
    selectAppointment(appointment) {
      let obj = {
        distancial: this.distancial,
        appointment: appointment,
      };
      this.$emit("update", obj);
    },

    async moveCalendar(val) {
      if (val) {
        this.date = moment(this.date).add("7", "d").toDate();
      } else {
        this.date = moment(this.date).subtract("7", "d").toDate();
      }
    },
  },
};
</script>
